// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"116303ca19546d48723f55ecd323415e5b9692fe"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
if (process.env.NEXT_PUBLIC_ENABLE_SENTRY !== 'true') {
  console.log('Sentry disabled');
} else {
  Sentry.init({
    dsn: 'https://642f26bdf2809425b915349096899d92@o4508769592213504.ingest.us.sentry.io/4508769593982976',
    beforeSend(event) {
      const requestUrl = event?.request?.url || '';
      const stackFrames =
        event?.exception?.values?.[0]?.stacktrace?.frames || [];
      const ignoreSources = [
        'stape.io/ip-request',
        'gtm.js', // Google Tag Manager
        'googletagmanager.com',
        'google-analytics.com',
        'yandex', // Yandex scripts
        'mc.yandex',
        'uaas.yandex',
        'yandex.ru',
        'hotjar', // Hotjar
        'clarity.ms', // Microsoft Clarity
        'facebook.net', // Meta Pixel,
        'analytics.google.com',
      ];

      const matchesIgnoredSource = ignoreSources.some(
        (src) =>
          requestUrl.includes(src) ||
          stackFrames.some((frame) => frame.filename?.includes(src))
      );

      if (matchesIgnoredSource) {
        return null; // Drop the event
      }

      return event; // Keep everything else
    },
    // Add optional integrations for additional features
    integrations: [Sentry.replayIntegration()],

    // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
    tracesSampleRate: 1,

    // Define how likely Replay events are sampled.
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.05,

    // Define how likely Replay events are sampled when an error occurs.
    replaysOnErrorSampleRate: 0.8,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
  });
}
